import {
  getFirestore,
  collection,
  doc,
  getDocs,
  setDoc,
  query,
  where,
} from "firebase/firestore";
import firebaseApp from "@/lib/firebase";
import {
  ProgressAndLastSeenEntry,
  ProgressEntryUpdate,
} from "@/types/progressAndLastSeen";

/**
 * Repository class for lastSeen collection operations
 * Handles CRUD operations for progress in Firestore
 */

export class LastSeenRepository {
  private db = getFirestore(firebaseApp);
  private collectionName = "lastSeen" as const;

  // Sets or updates the progress for a contentBlock for a user and course
  async setLastSeen(
    userId: string,
    courseId: string,
    contentBlockId: string
  ): Promise<void> {
    try {
      const id = `${userId}_${courseId}`;
      const progressEntry: ProgressEntryUpdate = {
        id,
        userId,
        courseId,
        contentBlockId,
      };

      const docRef = doc(this.db, this.collectionName, id);
      setDoc(docRef, { ...progressEntry });
    } catch (e) {
      console.error("Error setting last seen content block:", e);
    }
  }

  // Gets all episode progress values for a given course for a user.
  async getCourseLastSeen(
    userId: string,
    courseId: string
  ): Promise<string | null> {
    try {
      const progressCol = collection(this.db, this.collectionName);
      const queryRef = query(
        progressCol,
        where("courseId", "==", courseId),
        where("userId", "==", userId)
      );

      const docsSnap = await getDocs(queryRef);
      const docsArray = docsSnap.docs.map((doc) =>
        doc.data()
      ) as ProgressAndLastSeenEntry[];
      console.log("Retrieved last seen data:", docsArray);
      return docsArray[0]?.contentBlockId || null;
    } catch (e) {
      console.error("Error getting course last seen:", e);
      return null;
    }
  }
}

// Export singleton instance
export const lastSeenRepository = new LastSeenRepository();
